import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = "923214994888"; // ✅ Your WhatsApp number without '+'
  const message = "Hello! I have a question about your services."; // Optional default message
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="
        fixed bottom-5 right-5 
        bg-green-500 hover:bg-green-600 
        text-white rounded-full 
        w-14 h-14 
        flex items-center justify-center 
        shadow-lg hover:scale-110 transition-transform duration-300 
        z-50
      "
    >
      {/* WhatsApp Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="currentColor"
        className="w-8 h-8"
      >
        <path d="M16.002 3C9.374 3 4 8.374 4 15.002c0 2.653.853 5.098 2.306 7.086L5 29l7.088-1.844A11.939 11.939 0 0016 27c6.628 0 12.002-5.374 12.002-11.998C28.002 8.374 22.628 3 16.002 3zm0 22.004c-1.865 0-3.606-.509-5.108-1.395l-.366-.216-4.216 1.097 1.13-4.104-.236-.38A9.934 9.934 0 016.002 15C6 9.476 10.478 5 16.002 5 21.526 5 26 9.478 26 15.002S21.526 25.004 16.002 25.004zm5.548-7.475c-.305-.152-1.803-.89-2.083-.99-.28-.102-.484-.152-.688.152s-.79.99-.97 1.19c-.18.203-.357.228-.662.077-.305-.153-1.288-.474-2.452-1.51-.906-.808-1.518-1.81-1.696-2.114-.18-.305-.019-.469.134-.621.138-.138.305-.356.458-.534.152-.18.203-.305.305-.509.101-.203.05-.381-.025-.534-.077-.152-.689-1.663-.945-2.282-.248-.596-.5-.514-.689-.523l-.59-.012c-.203 0-.534.076-.814.38-.28.305-1.07 1.045-1.07 2.55 0 1.504 1.095 2.955 1.248 3.159.152.203 2.153 3.287 5.218 4.609.73.315 1.3.503 1.744.643.732.233 1.398.2 1.924.121.588-.088 1.803-.738 2.058-1.45.254-.713.254-1.323.178-1.45-.075-.127-.28-.203-.584-.356z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
